import Vue from "vue";
import Router from "vue-router";
// import { createRouter } from "vue-router";
import layout_font from "@/layout_font";
import Layout from "@/layout/index";
import { getInfo, getMenuBar } from "@/utils/auth";
import store from "@/store";

Vue.use(Router);

let router = new Router({
  // const router = createRouter({
  routes: [
    {
      path: "/",
      component: layout_font,
      hidden: true,
      redirect: "/Home",
      children: [
        {
          path: "Home",
          name: "首页",
          component: () => import("@/views/front/frontHome/Home")
        },
        {
          path: "/AllCourses",
          name: "AllCourses",
          meta: {
            title: "全部课程"
          },
          component: () => import("@/views/front/AllCourses")
        },
        {
          path: "UserAgreement",
          name: "UserAgreement",
          meta: {
            title: "用户"
          },
          component: () =>
            import("@/views/front/UserAgreement/UserAgreement.vue")
        },
        {
          // 视频播放
          path: "VideoPlayback",
          name: "VideoPlayback",
          meta: {
            title: "视频播放"
          },
          component: () =>
            import("@/views/front/VideoPlayback/VideoPlayback.vue")
        },
        {
          // 宠播社区
          path: "IndustryBBS",
          name: "IndustryBBS",
          meta: {
            title: "宠播社区"
          },
          component: () => import("@/views/front/IndustryBBS/IndustryBBS.vue")
        },
        {
          // 论坛详情
          path: "BBSdeatils",
          name: "BBSdeatils",
          meta: {
            title: "论坛详情"
          },
          component: () => import("@/views/front/IndustryBBS/BBSdeatils.vue")
        },
        {
          // 论坛详情
          path: "BBSdeatils_s",
          name: "BBSdeatils_s",
          meta: {
            title: "论坛详情"
          },
          component: () => import("@/views/front/IndustryBBS/BBSdeatils_s.vue")
        },
        {
          // 发帖
          path: "Posting",
          name: "Posting",
          meta: {
            title: "发帖"
          },
          component: () => import("@/views/front/IndustryBBS/Posting.vue")
        },
        {
          // 个人中心
          path: "personalCenter",
          name: "personalCenter",
          meta: {
            title: "个人中心"
          },
          component: () =>
            import("@/views/front/personalCenter/personalCenter.vue")
        },
        {
          // 个人中心_s
          path: "personalCenter_s",
          name: "personalCenter_s",
          meta: {
            title: "个人中心_s"
          },
          component: () =>
            import("@/views/front/personalCenter/personalCenter_s.vue")
        }
      ]
    },
    {
      path: "/CourseManagement",
      component: Layout,
      // component: resolve => require(["../layout"], resolve),
      meta: {
        PermissionID: "36130170-89a1-11ee-8e66-34735aa3266e",
        title: "课程管理"
      },
      children: [
        {
          path: "/CourseManagement",
          name: "content-course",
          meta: {
            PermissionID: "36130170-89a1-11ee-8e66-34735aa3266e",
            title: "课程管理",
            noCache: true
          },
          component: () => import("@/views/back/CourseManagement")
        }
      ]
    },
    {
      path: "/BBS",
      component: Layout,
      children: [
        {
          path: "/BBS",
          name: "content-BBS",
          meta: {
            PermissionID: "7407811a-89a1-11ee-8e66-34735aa3266e",
            title: "宠播社区",
            noCache: true
          },
          component: () => import("@/views/back/BBSmanagement")
        }
      ]
    },
    {
      path: "/comments",
      component: Layout,
      children: [
        {
          path: "/comments",
          name: "content-comments",
          meta: {
            PermissionID: "880769ec-89a1-11ee-8e66-34735aa3266e",
            title: "评论管理",
            noCache: true
          },
          component: () => import("@/views/back/commentsManagement")
        }
      ]
    },
    {
      path: "/user",
      component: Layout,
      children: [
        {
          path: "/user",
          name: "content-user",
          meta: {
            PermissionID: "985f43ad-89a1-11ee-8e66-34735aa3266e",
            title: "用户管理",
            noCache: true
          },
          component: () => import("@/views/back/userManagement")
        }
      ]
    },
    {
      path: "/lecturer",
      component: Layout,
      children: [
        {
          path: "/lecture",
          name: "content-lecturer",
          meta: {
            PermissionID: "a7d0ba9d-89a1-11ee-8e66-34735aa3266e",
            title: "讲师管理",
            noCache: true
          },
          component: () => import("@/views/back/lecturerManagement")
        }
      ]
    },
    {
      path: "/banner",
      component: Layout,
      children: [
        {
          path: "/banner",
          name: "content-banner",
          meta: {
            PermissionID: "be4a3df4-89a1-11ee-8e66-34735aa3266e",
            title: "banner管理",
            noCache: true
          },
          component: () => import("@/views/back/bannerManagement")
        }
      ]
    },
    {
      path: "/reception",
      component: Layout,
      children: [
        {
          path: "/reception",
          name: "customer-reception",
          meta: {
            PermissionID: "0af58a47-89a2-11ee-8e66-34735aa3266e",
            title: "客户接待",
            noCache: true
          },
          component: () =>
            import("@/views/back/Chat/CustomerReception/CustomerReception")
        }
      ]
    },
    {
      path: "/Account",
      component: Layout,
      children: [
        {
          path: "/Account",
          name: "Account-management",
          meta: {
            PermissionID: "4f1252ce-89a2-11ee-8e66-34735aa3266e",
            title: "账户管理",
            noCache: true
          },
          component: () =>
            import("@/views/back/Chat/AccountManagement/AccountManagement")
        }
      ]
    },
    {
      path: "/Problem",
      component: Layout,
      children: [
        {
          path: "/Problem",
          name: "Problem-management",
          meta: {
            PermissionID: "2a2e8356-89a2-11ee-8e66-34735aa3266e",
            title: "问题管理",
            noCache: true
          },
          component: () =>
            import("@/views/back/ProblemManagement/ProblemManagement")
        }
      ]
    },
    {
      path: "/Product",
      component: Layout,
      children: [
        {
          path: "/Product",
          name: "Product-support",
          meta: {
            PermissionID: "f2b3feef-89a1-11ee-8e66-34735aa3266e",
            title: "产品支持",
            noCache: true
          },
          component: () => import("@/views/back/ProductSupport/ProductSupport")
        }
      ]
    },
    {
      path: "/Record",
      component: Layout,
      children: [
        {
          path: "/Record",
          name: "Record-management",
          meta: {
            PermissionID: "3bc8280f-89a2-11ee-8e66-34735aa3266e",
            title: "接待记录管理",
            noCache: true
          },
          component: () =>
            import("@/views/back/RecordManagement/RecordManagement")
        }
      ]
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/404.vue"),
      hidden: true
    },
    {
      path: '/Vet',
      name: 'Vet',
      component: () => import('@/views/vet/index.vue'),
      hidden: true
    },
    {
      path: '/Lis',
      name: 'Lis',
      component: () => import('@/views/lis/index.vue'),
      hidden: true
    }
  ]
});

//要添加的代码 点击路由调转，回到顶部
router.beforeEach((to, from, next) => {
  const skipArr = [
    "content-banner",
    "content-course",
    "content-BBS",
    "content-comments",
    "content-user",
    "content-lecturer",
    "customer-reception", // 客户接待
    "Account-management", // 账户管理
    "Record-management", // 接待记录管理
    "Problem-management", // 问题管理
    "Product-support" // 产品支持
  ];
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  // 如果是访问 file-search 页面，直接放行
  if (to.path === "/File/Search") {
    next();
    return;
  }
  const UserInfo = getInfo();
  if (!UserInfo) {
    next();
    return;
  }
  if (UserInfo.FullID === 2 || UserInfo.FullID === 3) {
    if (skipArr.includes(to.name)) {
      next("/Home");
    } else {
      next();
    }
  } else {
    const MenuBar = getMenuBar() || [];
    const findSuccess = MenuBar.find(item => {
      return item.children[0].meta.PermissionID === to.meta.PermissionID;
    });
    if (findSuccess) {
      next();
    } else {
      store.dispatch("users/resetToken");
      next("/Home");
    }
  }
});

// router.$addRoutes = params => {
//   router.matcher = new Router({ mode: "history" }).matcher;
//   router.addRoutes(params);
// };

// 阻止重复路由
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js